import { FetcherPaginated, FetchParams } from "@shared/types";
import {
    PostResult,
    RequestCriteriaType,
} from "@infrastructure/Services/PostService.types";
import {
    PostsCollectionUpdatesResult,
    PostType,
} from "../Components/Post/Post.types";
import {
    getGroupPosts,
    getGroupPostsUpdates,
} from "@infrastructure/Services/GroupService";
import dayjs from "dayjs";
import { mapPostData } from "./PostDataFetcher";

export const groupPostsFetcher: FetcherPaginated<PostType> = (
    fetchParams: FetchParams,
    prepareParams: object = {},
) => {
    const { groupId } = fetchParams;
    const sortCriteria = extractCursor(fetchParams.sortCriteria);
    return getGroupPosts(groupId.toString(), sortCriteria).then(
        (groupPostsCollectionApiResponse) => {
            return groupPostsCollectionApiResponse.posts.map(
                (post: PostResult) => {
                    return {
                        ...mapPostData(post, prepareParams),
                        cursor: {
                            id: post.id,
                            value: dayjs(post.createdAt).unix(),
                        },
                    };
                },
            );
        },
    );
};

export const groupPostsUpdatesFetcher = async (
    fetchParams: FetchParams,
    prepareParams: object = {},
): Promise<PostsCollectionUpdatesResult> => {
    const { groupId } = fetchParams;
    const sortCriteria = extractCursor(fetchParams.sortCriteria);
    let deletedPosts: Array<number> = [];
    const posts = await getGroupPostsUpdates(
        groupId.toString(),
        sortCriteria,
    ).then((groupPostsCollectionApiResponse) => {
        deletedPosts = groupPostsCollectionApiResponse.deletedPosts;
        return groupPostsCollectionApiResponse.posts.map((post: PostResult) =>
            mapPostData(post, prepareParams),
        );
    });

    return {
        posts,
        deletedPosts,
    };
};

function extractCursor(sortCriteria: RequestCriteriaType | undefined) {
    if (!sortCriteria) {
        return sortCriteria;
    }
    const { cursor, ...properties } = sortCriteria;

    if (cursor && typeof cursor === "object") {
        return {
            ...properties,
            "cursor[id]": cursor.id,
            "cursor[value]": cursor.value,
        };
    }

    return sortCriteria;
}
